import { Grid } from '@mui/material';
import useSelectionValuesData from "helpers/context/SelectionValues/useSelectionValuesData";
import OrdersGrid from '../Orders/OrdersGrid';
import SelectOrderType, { OrderDataTypeEnum } from '../Orders/SelectOrderType';
import PickupsGrid from '../Pickups/PickupsGrid';
import RMAsGrid from '../RMAs/RMAsGrid';
import { useState } from "react";
import { OrderTypesEnum } from "helpers/enums";
import OrderTypeFilter from "./OrderTypeFilter";
import useIsMobile from "helpers/hooks/useIsMobile";
import useApplicationInfo from "helpers/context/Application/useApplicationInfo";

const DashboardOrders = () => {

    const { dashboardOrderType } = useSelectionValuesData();
    const isMobile = useIsMobile();
    const applicationInfo = useApplicationInfo();

    const [selectedOrderTypes, setSelectedOrderTypes] = useState<OrderTypesEnum[]>(applicationInfo.webVisibleOrderTypes);

    return <>
        <Grid container direction="row" mt={1} mb={1} columnSpacing={1}>
            <Grid item xs={isMobile ? 6 : 3}>
                <SelectOrderType />
            </Grid>
            {dashboardOrderType === OrderDataTypeEnum.Orders && applicationInfo.webVisibleOrderTypes.length > 1 &&
                <Grid item xs={isMobile ? 6 : 3}>
                    <OrderTypeFilter
                        orderTypesDataSource={applicationInfo.webVisibleOrderTypes}
                        selectedOrderTypes={selectedOrderTypes}
                        setSelectedOrderTypes={setSelectedOrderTypes}
                    />
                </Grid>
            }
        </Grid>

        {dashboardOrderType === OrderDataTypeEnum.Orders && <OrdersGrid selectedOrderTypes={selectedOrderTypes} />}
        {dashboardOrderType === OrderDataTypeEnum.Pickups && <PickupsGrid />}
        {dashboardOrderType === OrderDataTypeEnum.RMAs && <RMAsGrid />}
    </>;
};

export default DashboardOrders;